import type { BusinessBrief, BusinessBriefData, MeResponse, MeWorkspace } from '@doneverse/shared'
import { api } from '../api/index.js'
import type { Profile } from '../api/index.js'
import { isNotFoundError } from '../api/index.js'

export const profileService = {
  fetchBusinessBrief: async () => {
    try {
      return await api.get('/business-brief').json<BusinessBrief | null>()
    } catch (error: unknown) {
      if (isNotFoundError(error)) return null
      throw error
    }
  },

  fetchProfile: async (userId?: string): Promise<Profile> => {
    const path = userId ? `/v1/me?user_id=${encodeURIComponent(userId)}` : '/v1/me'
    const me = await api.get(path).json<MeResponse>()
    return { ...me, business_brief: null }
  },

  fetchMyWorkspaces: async (): Promise<MeWorkspace[]> => {
    const { workspaces } = await api.get('/v1/me/workspaces').json<{ workspaces: MeWorkspace[] }>()
    return workspaces
  },

  updateBusinessBrief: async (businessBrief: BusinessBriefData) => {
    await api.put({ data: businessBrief }, '/business-brief').res()
  },
}
